import { useI18n } from "../i18n/index.ts";
import type { BasemapId } from "../map/map-style.ts";

export interface BasemapToggleProps {
  readonly basemap: BasemapId;
  readonly onChange: (basemap: BasemapId) => void;
}

const NEXT: Record<BasemapId, BasemapId> = { night: "day", day: "night" };

/** Lune ou soleil : ce vers quoi le bouton fait basculer, pas l'état courant. */
const GLYPH: Record<BasemapId, string> = { night: "☀", day: "☾" };

export const BasemapToggle = ({ basemap, onChange }: BasemapToggleProps): React.ReactElement => {
  const { t } = useI18n();
  const next = NEXT[basemap];

  return (
    <button
      type="button"
      className="button button--round"
      aria-label={t.basemap.switchTo(t.basemap[next])}
      title={t.basemap[next]}
      onClick={() => onChange(next)}
    >
      <span aria-hidden="true">{GLYPH[basemap]}</span>
    </button>
  );
};
